import React, { useContext } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { StringContext } from "./StringProvider";
import { selectIsCuvamaUser } from "../store/reducers";
import { themeProp } from "../theme";
import { useFeature } from "./FeaturesProvider";
import Features from "../utils/constants/Features";

const FloatingButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background-color: ${themeProp("palette.primary")};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;

  &:hover {
    background-color: ${themeProp("palette.primaryDark")};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DebugModeButton = ({ isCuvamaUser }) => {
  const { isDebugMode, setIsDebugMode } = useContext(StringContext);
  const isDebugModeAvailable = useFeature(
    Features.IS_DEBUG_MODE_AVAILABLE,
    false
  );

  if (!isCuvamaUser || !isDebugModeAvailable) {
    return null;
  }

  const handleToggle = () => {
    setIsDebugMode(!isDebugMode);
  };

  return (
    <FloatingButton onClick={handleToggle}>
      Debug Mode: {isDebugMode ? "On" : "Off"}
    </FloatingButton>
  );
};

const mapStateToProps = (state) => ({
  isCuvamaUser: selectIsCuvamaUser(state)
});

export default connect(mapStateToProps)(DebugModeButton);
